import { TEMPLATE_NAME_MAP } from '~/constants/template';
import { useCGTemplateContext } from '../contexts';
import { TemplateType } from '~/types/template';
import { useMemo } from 'react';

const TEMPLATE_TYPE_ORDER = [
  TemplateType.HOME,
  TemplateType.PAGE,
  TemplateType.ARTICLE,
  TemplateType.COLLECTION,
  TemplateType.PRODUCT,
];

export interface IVariantCountControlType {
  type: TemplateType;
  name?: string;
  count: number;
}
export const useCGTemplateCountControlType = () => {
  const { campaignGroupCampaigns } = useCGTemplateContext();

  const listVariantControl = useMemo(() => {
    return campaignGroupCampaigns
      .flatMap((campaign) => campaign.variants)
      .filter((variant) => variant?.isOrigin && !!variant.templateSuffix)
      .map((variant) => variant?.templateType as TemplateType)
      .filter((type) => type !== undefined);
  }, [campaignGroupCampaigns]);

  const listPairType = useMemo<IVariantCountControlType[]>(() => {
    const typeCounts = listVariantControl.reduce(
      (acc, type) => {
        acc[type] = (acc[type] || 0) + 1;
        return acc;
      },
      {} as Record<TemplateType, number>,
    );
    return TEMPLATE_TYPE_ORDER.filter((type) => typeCounts[type]).map((type) => ({
      type,
      name: TEMPLATE_NAME_MAP[type],
      count: typeCounts[type],
    }));
  }, [listVariantControl]);

  return {
    listPairType,
  };
};
